var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.skeletonName)?_c('div',{staticClass:"skeleton-wrapper"},[_c(_vm.skeletonName,{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }